import { render, staticRenderFns } from "./ManageCases.vue?vue&type=template&id=3438c0ab"
import script from "./ManageCases.vue?vue&type=script&lang=js"
export * from "./ManageCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports